import React from 'react';
import { Accordion, Form, Table } from 'react-bootstrap';

import DepartmentHeader from "../../../components/v2/DepartmentHeader"

export default function SetupStep2(props) {
    /* Incoming Properties */
    /* 
     * props.mode
     * props.departmentId
     * props.departments
     * props.programId
     * props.onProgramSelect
     * props.programLearningOutcomes
     * props.activePrograms
     * props.onLearningOutcomeChanged
     * props.learningOutcomeMappings
     * 
     */
    const prefix = "program-"
    const toDefaultValue = (programId, sloId, themeId) => {
        let key = 'program-' + programId + '_slo-' + sloId + '_theme-' + themeId
        return (key in props.learningOutcomeMappings) ? props.learningOutcomeMappings[key].toLowerCase() : 'no'
    }

    let department;
    let departmentId;
    
    if (props.departmentId) {
        department = props.departments.find((d) => d.departmentId == props.departmentId)
        departmentId = props.departmentId
    } else if (props.departments) {
        department = props.departments.find((d) => d.departmentId == props.department.departmentId)
        departmentId = props.department.departmentId
    }

    let learningOutcomes = props.programLearningOutcomes
    let programs = department.programList
    let selectedPrograms = []
    for (const [key,value] of Object.entries(props.activePrograms)) {
        if (value === 'yes') {
            selectedPrograms.push(programs.find(p => p.programId == key))
        }
    }

    // defaultTabs is provided to Accordion to expand all accordion items by default.
    let defaultTabs = Array.from(selectedPrograms, (p,k) => 'program-' + k)
    
    return (
        <React.Fragment>
            <div className="p-5 pb-md-4 mx-auto">
                <div className="p-1 text-center">
                    <h3>Map Learning Outcomes to Universal Themes</h3>
                    <p className="fs-6 text-muted" style={{"textIndent":"50px"}}>
                        Decide which Universal Themes(s) to associate each learning outcome with.
                        For each degree, certificate, and gen ed area being set up, each outcome
                        must be associated with at least one universal theme and each universal
                        theme must have at least one learning outcome associated with it. Please 
                        review background information about mapping outcomes to the Universal Themes 
                        before continuing: &nbsp;
                        <a href="https://rise.articulate.com/share/j_mn9QufRSYSQLrSlhQRxud_JKUnll9X#/lessons/ASmX6UekTrjMm2DbqojZ-q91AwxMnDLi" target="_blank" rel="noopener noreferrer">View</a>
                    </p>
                </div>

                <DepartmentHeader text={department?.longName} />
                
                <Accordion defaultActiveKey={defaultTabs} alwaysOpen>
                {
                    selectedPrograms.map((program, k) => 
                        <Accordion.Item eventKey={prefix + k} key={k}>
                            <Accordion.Header>{program.longName}</Accordion.Header>
                            <Accordion.Body>
                                <Table id={k}>
                                    <thead>
                                        <tr>
                                            <th>Learning Outcome</th>
                                            <th className="mx-auto text-center">Thinking in Action</th>
                                            <th className="mx-auto text-center">Practicing Community</th>
                                            <th className="mx-auto text-center">Professional Skills</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {learningOutcomes &&
                                            Object.keys(learningOutcomes[program.programId]).map((key, index) => 
                                                <tr key={index}>
                                                    <td>
                                                        {learningOutcomes[program.programId][key].text}
                                                    </td>
                                                    <td>
                                                        <Form.Select 
                                                            onChange={props.onLearningOutcomeChanged}
                                                            name={'program-' + program.programId + '_slo-' + learningOutcomes[program.programId][key].sloId + '_theme-1'}
                                                            aria-label="Program assessment included in report."
                                                            defaultValue={toDefaultValue(program.programId, learningOutcomes[program.programId][key].sloId, 1)}
                                                            >
                                                            <option value="no">No</option>
                                                            <option value="yes">Yes</option>
                                                        </Form.Select>
                                                    </td>
                                                    <td>
                                                        <Form.Select 
                                                            onChange={props.onLearningOutcomeChanged}
                                                            name={'program-' + program.programId + '_slo-' + learningOutcomes[program.programId][key].sloId + '_theme-2'}
                                                            aria-label="Program assessment included in report."
                                                            defaultValue={toDefaultValue(program.programId, learningOutcomes[program.programId][key].sloId, 2)}
                                                            >
                                                            <option value="no">No</option>
                                                            <option value="yes">Yes</option>
                                                        </Form.Select>
                                                    </td>
                                                    <td>
                                                        <Form.Select 
                                                            onChange={props.onLearningOutcomeChanged}
                                                            name={'program-' + program.programId + '_slo-' + learningOutcomes[program.programId][key].sloId + '_theme-3'}
                                                            aria-label="Program assessment included in report."
                                                            defaultValue={toDefaultValue(program.programId, learningOutcomes[program.programId][key].sloId, 3)}
                                                            >
                                                            <option value="no">No</option>
                                                            <option value="yes">Yes</option>
                                                        </Form.Select>
                                                    </td>
                                                </tr>
                                            )
                                        }   
                                    </tbody>
                                </Table>
                            </Accordion.Body>
                        </Accordion.Item>
                    )
                }
                </Accordion>
            </div>
        </React.Fragment>
    )
}
